package com.xtream.data_kmp.db

import androidx.room3.ColumnTypeConverter
import com.xtream.data_kmp.db.tables.StreamType
import kotlinx.serialization.json.Json

internal object StringListConverter {
    @ColumnTypeConverter
    fun stringToList(value: String?): List<String?>? {

        return if(value.isNullOrEmpty())null else Json.decodeFromString<List<String?>>(value)
    }

    @ColumnTypeConverter
    fun listToString(list: List<String?>?): String? {
        return if(list.isNullOrEmpty()) null else Json.encodeToString<List<String?>>(list)
    }
}


class StreamTypeConverter {

    @ColumnTypeConverter
    fun fromStreamType(type: StreamType): String = type.name

    @ColumnTypeConverter
    fun toStreamType(value: String): StreamType = StreamType.valueOf(value)
}